import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../../../../api/agent";
import { AppFilter } from "../../../../models/app/AppModels";
import { CheckoutDetail } from "../../../../models/features/Gravity/CheckoutDetail";

export const CustomerApi = createApi({
  reducerPath: "CustomerApi",
  baseQuery: axiosBaseQuery(),

  endpoints: (build) => ({
    getCustomerOrders: build.mutation<
      any,
      {
        everestDmsDealerId: string;
        customerId?: string;
        email?: string;
        paging: AppFilter;
        orderType: string;
      }
    >({
      query: (data) => ({
        url: `api/Customer/CustomerOrders`,
        method: "post",
        data: data,
      }),
    }),
    getTransactionToken: build.mutation<any, { data: CheckoutDetail }>({
      query: ({ data }) => ({
        url: `api/GetTransactionToken`,
        method: "post",
        data: data,
      }),
    }),
    addTransactionHistory: build.mutation<any, { data: any }>({
      query: ({ data }) => ({
        url: `api/AddTransactionHistory`,
        method: "post",
        data: data,
      }),
    }),
    setCustomerCredentials: build.mutation<any, { data: any }>({
      query: ({ data }) => ({
        url: `api/Account/SetCustomerCredentials`,
        method: "post",
        data: data,
      }),
    }),
    getCustomerSummary: build.mutation<
      any,
      {
        customerId: string;
        dealerId: string;
      }
    >({
      query: (data) => ({
        url: `api/Customer/GetCustomerSummary`,
        method: "post",
        data: data,
      }),
    }),
  }),
});

export const {
  useGetCustomerOrdersMutation,
  useGetTransactionTokenMutation,
  useAddTransactionHistoryMutation,
  useSetCustomerCredentialsMutation,
  useGetCustomerSummaryMutation,
} = CustomerApi;
export const shopifySettingReducer = CustomerApi.reducer;
